export default __webpack_public_path__ + "static/media/gmail.92471c7a.svg";